"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var TeachingBubble_1 = require("office-ui-fabric-react/lib/TeachingBubble");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var owa_lightning_1 = require("owa-lightning");
var owa_header_store_1 = require("owa-header-store");
var owa_analytics_1 = require("owa-analytics");
var owa_configurator_strings_1 = require("owa-strings/owa-configurator-strings");
var SettingPanelFirstRunCallout = /** @class */ (function (_super) {
    tslib_1.__extends(SettingPanelFirstRunCallout, _super);
    function SettingPanelFirstRunCallout(props) {
        var _this = _super.call(this, props) || this;
        _this.onGotIt = function () {
            owa_lightning_1.lighted(_this.props.lid);
        };
        _this.onNotNow = function () {
            owa_analytics_1.logUsage('SettingPanelFirstRunNotNow');
            owa_header_store_1.toggleCharm(4 /* SettingsCharm */);
            owa_lightning_1.lighted(_this.props.lid);
            owa_lightning_1.eventMgr.emit(owa_lightning_1.SettingPanelFirstRunCalloutDismissedEvent);
        };
        return _this;
    }
    SettingPanelFirstRunCallout.prototype.render = function () {
        var gotItButtonProps = {
            buttonType: Button_1.ButtonType.primary,
            children: owa_configurator_strings_1.default.callout_Gotit,
            onClick: this.onGotIt,
        };
        var notNowButtonProps = {
            children: owa_configurator_strings_1.default.callout_Notnow,
            onClick: this.onNotNow,
        };
        return (React.createElement(TeachingBubble_1.TeachingBubble, { calloutProps: {
                beakWidth: 15,
                directionalHint: 12 /* rightCenter */,
                gapSpace: 30,
            }, targetElement: this.props.target(), hasCloseIcon: true, headline: owa_configurator_strings_1.default.callout_Panel_Title, hasSmallHeadline: true, primaryButtonProps: gotItButtonProps, secondaryButtonProps: notNowButtonProps, onDismiss: this.onGotIt }, owa_configurator_strings_1.default.callout_Panel_Body));
    };
    SettingPanelFirstRunCallout = tslib_1.__decorate([
        mobx_react_1.observer,
        owa_lightning_1.lightable
    ], SettingPanelFirstRunCallout);
    return SettingPanelFirstRunCallout;
}(React.Component));
exports.SettingPanelFirstRunCallout = SettingPanelFirstRunCallout;
//# sourceMappingURL=SettingPanelFirstRunCallout.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/quick/SettingPanelFirstRunCallout.js
// module id = 5313
// module chunks = 2